import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { PageHero, SectionLabel } from "../components/site/Bits";
import Reveal from "../components/site/Reveal";
import { DOMESTIC_PRICES, VALET_PRICES } from "../data/content";

function PriceTable({ rows }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/5">
      <table className="w-full text-left">
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.service} className={`${i % 2 ? "bg-mist" : "bg-white"} hover:bg-brandgreen/5 transition-colors`}>
              <td className="px-6 py-5 font-heading font-medium text-navy text-lg tracking-tight">{r.service}</td>
              <td className="px-6 py-5 text-right font-heading font-bold text-brandgreen text-lg whitespace-nowrap">{r.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Prices() {
  return (
    <div data-testid="prices-page">
      <PageHero
        crumb="Prices"
        label="Price List"
        title="Clear, honest pricing."
        subtitle="No hidden fees, no surprises. Here's what our services cost — and remember, new customers get 10% off their first booking."
      />

      <section className="py-24 lg:py-32 bg-white">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid gap-16 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal><SectionLabel>Domestic Cleaning</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 mb-8 font-heading font-extrabold text-navy text-3xl sm:text-4xl tracking-tighter">
                Home cleaning
              </h2>
            </Reveal>
            <Reveal delay={0.1}><PriceTable rows={DOMESTIC_PRICES} /></Reveal>
          </div>

          <div>
            <Reveal><SectionLabel>Car Valeting</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 mb-8 font-heading font-extrabold text-navy text-3xl sm:text-4xl tracking-tighter">
                Mobile valeting
              </h2>
            </Reveal>
            <Reveal delay={0.1}><PriceTable rows={VALET_PRICES} /></Reveal>
          </div>
        </div>

        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 mt-16">
          <Reveal>
            <div className="rounded-2xl border border-dashed border-navy/20 bg-mist p-8 flex items-start gap-4">
              <span className="grid place-items-center w-11 h-11 rounded-xl bg-navy text-white shrink-0">
                <Clock className="w-5 h-5" />
              </span>
              <div>
                <h3 className="font-heading font-bold text-navy text-xl tracking-tight">Commercial Cleaning</h3>
                <p className="mt-1 text-muted-foreground">
                  Coming soon — office, retail and communal space cleaning contracts. Register your interest via our contact page.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-navy text-white">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter max-w-xl">
            Get your 10% first-booking discount.
          </h2>
          <Link
            to="/book"
            data-testid="prices-cta-book"
            className="inline-flex items-center gap-2 rounded-full bg-brandgreen px-8 py-4 font-semibold hover:bg-white hover:text-navy transition-colors duration-300 shrink-0"
          >
            Book Now <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
